import {
  WISHLIST_TOGGLE_PRODUCT,
  WISHLIST_SET_EMAIL,
  WISHLIST_SHOW_EMAIL_FORM,
  WISHLIST_HIDE_EMAIL_FORM,
  WISHLIST_SEND_TO_EMAIL
} from "../../store/constants/hwk";

export function toggleProduct(productSku = null) {
  return {
    type: WISHLIST_TOGGLE_PRODUCT,
    productSku
  };
}

export function setEmail(email = null) {
  return {
    type: WISHLIST_SET_EMAIL,
    email
  };
}

export function showEmailForm() {
  return {
    type: WISHLIST_SHOW_EMAIL_FORM
  };
}

export function hideEmailForm() {
  return {
    type: WISHLIST_HIDE_EMAIL_FORM
  };
}

export function sendToEmail() {
  return {
    type: WISHLIST_SEND_TO_EMAIL
  };
}
